import { Injectable } from '@angular/core';
import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Operation } from './operation';
import { OperationService } from './operation.service';
import { lookupParam } from '../nav/utils';

@Injectable()
export class OperationResolver implements Resolve<Operation> {

  constructor(
    private router: Router,
    private operationService: OperationService
  ) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Operation | Observable<Operation> | Promise<Operation> {
    return new Promise<Operation>(async (resolve, reject) => {

      let operation_id = lookupParam(route, 'operation_id');

      this.operationService
        .operation(operation_id)
        .subscribe((operation) => {
          
          if(operation) {
            return resolve(operation);
          }
          else {
            this.router.navigate(['operations']);
            return resolve(null);
          }
        });
    });
  }
}